import styled from "styled-components";

interface ITableHeader {
  enableCheckbox?: any;
}
export const TableHeader = styled.div<ITableHeader>`
  ${(props) => `
    color: ${props.theme.colors.gray};
    font-family: ${props.theme.fontFamilies.primaryFont};
    grid-template-columns: ${
      props.enableCheckbox ? "repeat(9, 1fr)" : "repeat(9 ,1fr)"
    };
  `}
  display: grid;
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  padding: 0 1.5rem;

  div {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .main-info-header {
    align-items: flex-start;
  }
`;

export const VolantesContainer = styled.div`
  background-color: rgba(23, 21, 120, 0.03);
  border-radius: 10px;
  box-sizing: border-box;
  padding: 1.5rem;
  width: 100%;
`;
